import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/returns.scss";
import "../css/delivery.scss";

function Delivery() {
  const email = siteConfig.contact?.email;
  const freeShippingThreshold = siteConfig.shipping?.freeThreshold || 250;
  const canadaRate = siteConfig.shipping?.canadaRate || 28;
  const internationalRate = siteConfig.shipping?.internationalRate || 45;
  const formatMoney = (value) =>
    new Intl.NumberFormat(siteConfig.currency?.locale || "en-US", {
      style: "currency",
      currency: siteConfig.currency?.code || "USD",
      maximumFractionDigits: 0,
    }).format(value);

  return (
    <main className="service-page shipping-page">
      <header className="service-hero">
        <p className="service-kicker">SERVICE / SHIPPING</p>
        <h1>From our floor to your door.</h1>
        <p>
          Orders are packed with care and dispatched on business days. Tracking
          is sent as soon as your parcel leaves us.
        </p>
      </header>

      <section className="service-highlights" aria-label="Shipping highlights">
        <div>
          <strong>1–3</strong>
          <span>Days to process</span>
        </div>
        <div>
          <strong>{formatMoney(freeShippingThreshold)}+</strong>
          <span>Free US ground shipping</span>
        </div>
        <div>
          <strong>Tracked</strong>
          <span>Every shipment</span>
        </div>
      </section>

      <div className="service-layout shipping-layout">
        <aside className="service-steps shipping-notes" aria-labelledby="shipping-notes-title">
          <p className="service-kicker">BEFORE IT SHIPS</p>
          <h2 id="shipping-notes-title">Good to know.</h2>
          <ul>
            <li>Orders placed after midday begin processing the next business day.</li>
            <li>Multiple-item orders may ship in more than one parcel.</li>
            <li>Carrier delays and customs processing fall outside delivery estimates.</li>
            <li>Check your address carefully before submitting the order.</li>
          </ul>
          <div className="service-action-row">
            <Link to="/contact">Shipping help</Link>
            {email && <a href={`mailto:${email}`}>Email service</a>}
          </div>
        </aside>

        <article className="service-copy shipping-copy">
          <section>
            <span>DELIVERY GUIDE</span>
            <h2>Estimated services</h2>
            <div className="shipping-table-wrap">
              <table className="shipping-table">
                <caption className="visually-hidden">Estimated shipping times and rates</caption>
                <thead>
                  <tr>
                    <th scope="col">Destination</th>
                    <th scope="col">Estimate</th>
                    <th scope="col">Rate</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Contiguous US</th>
                    <td>3–7 business days</td>
                    <td>Calculated / free over {formatMoney(freeShippingThreshold)}</td>
                  </tr>
                  <tr>
                    <th scope="row">Alaska &amp; Hawaii</th>
                    <td>5–10 business days</td>
                    <td>Calculated at checkout</td>
                  </tr>
                  <tr>
                    <th scope="row">Canada</th>
                    <td>6–12 business days</td>
                    <td>From {formatMoney(canadaRate)}</td>
                  </tr>
                  <tr>
                    <th scope="row">International</th>
                    <td>7–18 business days</td>
                    <td>From {formatMoney(internationalRate)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <span>TRACKING</span>
            <h2>Follow the parcel</h2>
            <p>
              A dispatch email includes your carrier and tracking link. It may
              take up to 24 hours for the first scan to appear. If tracking has
              not moved for several business days, contact us with your order number.
            </p>
          </section>

          <section>
            <span>INTERNATIONAL</span>
            <h2>Duties and local taxes</h2>
            <p>
              Import duties, taxes and brokerage charges may be collected by
              the destination country. Unless checkout states otherwise, these
              charges are the recipient’s responsibility and are not shipping fees.
            </p>
          </section>

          <section>
            <span>LOST / DAMAGED</span>
            <h2>Delivery problems</h2>
            <p>
              Inspect the parcel when it arrives. Report visible damage or a
              missing delivery promptly so we can work with the carrier on the
              next step.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Delivery;
